module.exports = __webpack_public_path__ + "static/media/highlights-screenshot.df3a21c8.png";